import { authAPI } from "../api";
import { LoginRequest } from "../model";
import { formatUser } from "../../../entities/auth";
import { tokenStorage } from "../../../shared/lib/token-storage";

/**
 * 로그인 Use Case
 * 검증 → API 호출 → 데이터 저장 → 포맷팅 전체 워크플로우
 */
export class LoginUseCase {
  async execute(credentials: LoginRequest) {
    // 폼 검증
    const userId = credentials.user_id || credentials.email;
    if (!userId || !credentials.password) {
      throw new Error("아이디와 비밀번호를 입력해주세요.");
    }

    // API 호출 (순수 HTTP)
    const response = await authAPI.login(credentials);

    // API 응답 전체 로깅 (디버그)
    console.log("Login API response:", response);

    // API 응답의 success 필드 확인
    if (!response.success) {
      throw new Error(response.message || "로그인에 실패했습니다.");
    }

    // 토큰 데이터 추출 (response.data에서)
    const tokenData = response.data;
    if (!tokenData) {
      throw new Error("로그인 응답에 토큰 정보가 없습니다.");
    }

    // 토큰 저장 (환경변수 설정 키 사용)
    if (tokenData.accessToken) {
      tokenStorage.setAccessToken(tokenData.accessToken);
      console.log("Access token saved:", tokenData.accessToken);
    }

    if (tokenData.refreshToken) {
      tokenStorage.setRefreshToken(tokenData.refreshToken);
      console.log("Refresh token saved:", tokenData.refreshToken);
    }

    // 프로필 ID 저장 (있으면)
    if (tokenData.userInfo?.user_id) {
      tokenStorage.setProfileId(tokenData.userInfo.user_id);
      console.log("Profile ID saved:", tokenData.userInfo.user_id);
    }

    // 저장된 토큰 확인 (디버그)
    console.log("localStorage keys:", Object.keys(localStorage));
    console.log("Stored access token:", tokenStorage.getAccessToken());

    // 사용자 정보 포맷팅
    let formattedUser = null;
    if (tokenData.userInfo) {
      // API 응답의 userInfo를 User 타입으로 변환
      // id는 UUID, user_id는 사용자가 입력한 아이디
      formattedUser = formatUser({
        id: tokenData.userInfo.id, // UUID
        user_id: tokenData.userInfo.user_id,
        name: tokenData.userInfo.username || "",
        email: tokenData.userInfo.email,
        phone_number: tokenData.userInfo.phone_number,
        user_type: tokenData.userInfo.user_type,
        role: tokenData.userInfo.provider,
      });
    }

    // 응답 데이터 포맷팅
    const formattedResponse = {
      ...response,
      user: formattedUser,
    };

    return formattedResponse;
  }
}

export const loginUseCase = new LoginUseCase();
